import { parseTweddleDomain } from 'lib/domain/parseTweddleDomain'

/**
 * Derives the cookie domain for Amplify CookieStorage from the current hostname.
 *
 * - v3 branded .io (production):     → .explorer.gd.tweddle.io
 * - v3 branded .tech (non-prod):     → .explorer.[env].gd.tweddle.tech
 * - All other hostnames (legacy, localhost): → undefined (same-origin only)
 */
export function getCookieDomain(hostname: string): string | undefined {
  const parsed = parseTweddleDomain(hostname)
  if (parsed) {
    return parsed.env === null
      ? '.explorer.gd.tweddle.io'
      : `.explorer.${parsed.env}.gd.tweddle.tech`
  }
  return undefined
}
